<app-agricola-navbar></app-agricola-navbar>

<div class="wizard-container">
  <div class="step-content-wrapper">
    <div class="step-body" [ngSwitch]="currentStepKey">
      <app-agricola-main-data-step
        *ngSwitchCase="'holder'"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        [group]="step1Group"
        [holderLoading]="holderLoading"
        [holderLoadedKey]="holderLoadedKey"
        [holderFromBank]="holderFromBank"
        [lockedClientFields]="lockedClientFields"
        (productApplied)="onProductApplied()"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()">
      </app-agricola-main-data-step>

      <app-agricola-declaratoria-step
        *ngSwitchCase="'declaratoria'"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        [group]="step2Group"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()">
      </app-agricola-declaratoria-step>

      <app-agricola-premium-step
        *ngSwitchCase="'premium'"
        [group]="step3Group"
        [pepGroup]="pepGroup"
        [productCode]="selectedProductCode"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        (productChange)="onPremiumProductChange($event)"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()">
      </app-agricola-premium-step>

      <app-agricola-beneficiaries-step
        *ngSwitchCase="'beneficiaries'"
        [group]="step4Group"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        [productCode]="selectedProductCode"
        [insuredIdentificationId]="insuredIdentificationId"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()">
      </app-agricola-beneficiaries-step>

      <app-agricola-dependants-step
        *ngSwitchCase="'dependants'"
        [group]="step4bGroup"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        [productCode]="selectedProductCode"
        [insuredIdentificationId]="insuredIdentificationId"
        [maxDependants]="maxDependants"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()">
      </app-agricola-dependants-step>

      <app-agricola-payment-step
        *ngSwitchCase="'payment'"
        [group]="step5Group"
        [wizardGroup]="wizardForm"
        [selectedIndex]="selectedIndex"
        [steps]="steps"
        (nextStep)="goToStep($event)"
        (previousStep)="goBack()"
        (returnHome)="goHome()"
        (returnToSearch)="goToClientSearch()"
        (policyIssued)="onPolicyIssued()">
      </app-agricola-payment-step>
    </div>
  </div>
</div>
